// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { ListTokens } from './type';

const listTokens: ListTokens = {
  listFontSize: 'Font-14',
  listFontColor: 'Neutral-text-5',
  listBorderColor: 'Neutral-border-1',
  listBorderRadius: 'Radius-lesser',
  listBorderWidth: 'Border-1',
  listItemPaddingY: 'Spacing-12',
  listItemPaddingX: 'Spacing-16',
  listItemBackgroundColor: 'Transparent',
  listSmallItemPaddingY: 'Spacing-8',
  listSmallItemPaddingX: 'Spacing-12',
  listSmallFontSize: 'Font-14',
  listLargeItemPaddingY: 'Spacing-16',
  listLargeItemPaddingX: 'Spacing-20',
  listLargeFontSize: 'Font-14',
  listPaginationMarginY: 'Spacing-12',
  listStripedBackgroundColor: 'Neutral-fill-2',
};

export default listTokens;
